import axios from 'axios'
import { getNewStoreData } from 'services/util'

// NewStore Proxy HTTP client
const newstoreClient = axios.create({
  baseURL: process.env.REACT_APP_NEWSTORE_PROXY_URL,
});

newstoreClient.interceptors.request.use(config => {
  const { accessToken } = getNewStoreData()
  if (accessToken) config.headers!['Authorization'] = `Bearer ${accessToken}`
  return config;
})

export default newstoreClient;
